"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.tileSizeClassRegistry = void 0;
const Tile_contracts_1 = require("./Tile.contracts");
/**
 * Registry that binds the `TileSize` with the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.tileSizeClassRegistry = {
    [Tile_contracts_1.TileSize.XL]: '--size-xl',
    [Tile_contracts_1.TileSize.L]: '--size-l',
    [Tile_contracts_1.TileSize.S]: '--size-s'
};
//# sourceMappingURL=Tile.config.js.map